import React from 'react';

import './tooltipCss.css';

export interface TooltipV2Props {
    children: React.ReactNode;
    content: string;
    maxWidth?: string;
    isHeading?: boolean;
}

export const testId = 'tooltip';

export function Tooltip({
    children,
    content,
    maxWidth,
    isHeading = false,
}: TooltipV2Props): JSX.Element {
    const tooltipStyle = {
        '--tooltip-max-width': maxWidth ?? '100%',
    } as React.CSSProperties;
    return (
        <div
            className={content !== '' ? 'tooltipSegment' : ''}
            data-tooltip={content}
            data-testid={testId}
            style={tooltipStyle}
            id={isHeading ? 'tooltipHeading' : ''}
        >
            {children}
        </div>
    );
}
